import { GetterTree } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IServicesState from './types/IServicesState';

const getters: GetterTree<IServicesState, IRootState> = {};

export default getters;
